module.exports = __webpack_public_path__ + "img/bksp.2bbe97b8.png";